module.exports = __webpack_public_path__ + "img/oak-swatch.912c5231.png";